import { Nullable } from "../../Extensions";
import { IControl } from "./Control";
import { NAMESPACE } from "./_Namespace";

export class ControlRef<TControl extends IControl = IControl>
{
    public static classNamespace = NAMESPACE + "ControlRef";
    public static className = "ControlRef";
    public static get classFullName() { return `${this.classNamespace}.${this.className}`; }

    current?: TControl;

    constructor(control?: Nullable<TControl>)
    {
        this.current = control ?? undefined;
    }
}